/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MAX_WIDTH = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Cell = _interopRequireDefault(require("../Cell"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MAX_WIDTH = 350;
exports.MAX_WIDTH = MAX_WIDTH;
var DragCell = function (_React$Component) {
  (0, _inherits2.default)(DragCell, _React$Component);
  var _super = _createSuper(DragCell);
  function DragCell(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, DragCell);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "left", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "right", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "top", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "height", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "width", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProps", function () {
      return _this.state.props || _this.props;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setProps", function (props) {
      _this.setState({
        props: props
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellMount", function (props, cell) {
      if (_this.left) {
        cell.setLeft(_this.left);
      }
      if (_this.right) {
        cell.setRight(_this.right);
      }
      if (_this.top) {
        cell.setTop(_this.top);
      }
      if (_this.height) {
        cell.setHeight(_this.height);
      }
      if (_this.width) {
        cell.setWidth(_this.width);
      }
      cell.setDragging(true);
      _this.cell = cell;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellUnmount", function () {
      _this.cell = null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (visible, callback) {
      if (!visible) {
        _this.top = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.height = undefined;
        _this.width = undefined;
      }
      _this.setState({
        visible: visible
      }, function () {
        if (_this.cell && visible) {
          _this.cell.setDragging(visible, callback);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
      _this.top = top;
      if (_this.cell && _this.state.visible) {
        _this.cell.setTop(top);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
      _this.height = height;
      if (_this.cell && _this.state.visible) {
        _this.cell.setHeight(height);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
      _this.width = width;
      if (_this.cell && _this.state.visible) {
        _this.cell.setWidth(width);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
      _this.left = left;
      if (_this.cell && _this.state.visible) {
        _this.cell.setLeft(left);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
      _this.right = right;
      if (_this.cell && _this.state.visible) {
        _this.cell.setRight(right);
      }
    });
    _this.state = {
      visible: false
    };
    return _this;
  }
  (0, _createClass2.default)(DragCell, [{
    key: "render",
    value: function render() {
      if (this.state.visible) {
        var props = this.getProps();
        var className = props.className ? "".concat(props.className, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
        var headerWrapperClassName = props.headerWrapperClassName ? "".concat(props.headerWrapperClassName, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
        var maxWidth = props.maxWidth ? Math.min(props.maxWidth, MAX_WIDTH) : MAX_WIDTH;
        var computedWidth = Math.min(props.computedWidth, maxWidth);
        return _react.default.createElement(_Cell.default, _objectSpread(_objectSpread({}, props), {}, {
          maxWidth: maxWidth,
          computedWidth: computedWidth,
          className: className,
          headerWrapperClassName: headerWrapperClassName,
          onMount: this.onCellMount,
          onUnmount: this.onCellUnmount
        }));
      }
      return null;
    }
  }]);
  return DragCell;
}(_react.default.Component);
exports.default = DragCell;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/HeaderLayout/DragCell.js
// module id = 560
// module chunks = 0